import script from "./base-command-action.vue?vue&type=script&lang=ts"
export * from "./base-command-action.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__